import React, { Fragment } from 'react'
import { FormattedMessage } from 'sb-react-intl'
import moment from 'moment'

import VisuallyHidden from 'components/ui/VisuallyHidden/VisuallyHidden'

import messages from './messages'


const AdaMessages = (props) => {
  const {
    ariaDescribedby,
    selectedProduct: { index, title, month, year }, totalCount,
    isProductSelected, isProductMoved, isProductDropped, isProductDeleted, isProductCanceled,
  } = props


  const monthName = moment(month, 'MM').format('MMMM')

  const values = {
    year,
    monthName,
    totalCount,
    productCount: index + 1,
    productTitle: title,
  }

  return (
    <Fragment>
      <VisuallyHidden>
        <FormattedMessage tagId={ariaDescribedby} {...messages.productDescription} />
        <span aria-live="assertive">
          {
            isProductSelected && (
              <FormattedMessage {...messages.productSelected} values={values} />
            )
          }
          {
            isProductMoved && (
              <FormattedMessage {...messages.productMoved} values={values} />
            )
          }
          {
            isProductDropped && (
              <FormattedMessage {...messages.productDropped} values={values} />
            )
          }
          {
            isProductDeleted && (
              <FormattedMessage {...messages.productDeleted} values={values} />
            )
          }
          {
            isProductCanceled && (
              <FormattedMessage {...messages.productCanceled} values={values} />
            )
          }
        </span>
      </VisuallyHidden>
    </Fragment>
  )
}


export default AdaMessages
